import React, { useState } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import * as Icons from '@fortawesome/free-solid-svg-icons';

import edit from '../../assets/images/icons/edit.svg';
import remove from '../../assets/images/icons/remove.svg';

import './keysfigures.scss';

export default function EditKeysFigures({ keyFigures , setRemoveAction , handleChange  , theme , isCompany }) {

  
  const [ displayAddKey , setDisplayAddKey ] = useState(false);
  const [ displayEditKey , setDisplayEditKey] = useState(false);
  const [ key, setKey] = useState();
  const [ keyIndex , setKeyIndex ] = useState();

  function addKey() {
    var keysList = keyFigures ? keyFigures : [];
    if (key) {
      if (!key.pos) key.pos = keyFigures.length + 1
      keysList.push(key)
      handleChange(keysList);
      setDisplayAddKey(false);
      setKey();
    }
  };

  function submitkey( ) {
    var keysList = [...keyFigures];
    keysList[keyIndex] = key;
    handleChange(keysList);
    setDisplayEditKey(false);
    setKey();
    setKeyIndex();
  }

  function removeKey(index) {
    var keysList = [...keyFigures];
    handleChange(keysList.filter(item => keysList.indexOf(item) !== index ));
  }

  function editKey(key, index ) {

    setKeyIndex(index);
    if (!key.pos) key.pos = index + 1
    setKey(key);
    setDisplayEditKey(true);
  }

  function addNewKey(e) {
    setDisplayAddKey(true)
  }


  function renderKeysList() {
    if (keyFigures && keyFigures.length) {
      return (
        <>
          {keyFigures.sort((a , b ) => a.pos - b.pos ).map(( key, i ) => {
            return (
              <div key={"key" + i } className="key-row">

                <div className="key-infos">
                  <h3 className="bold">
                    {key.pos !== 0 && <span>{key.pos} - </span>}
                    <span className={theme + "-color"}>{key?.number} {key.unit} </span>
                    <span>{key.text}</span>
                  </h3>
                </div>

                <div className="icons">
                  <button
                    type="button"
                    onClick={() => editKey(key, i)}>
                    <img src={edit} alt="edit"/>
                  </button>
                  <button
                    type="button"
                    onClick={() => setRemoveAction({ function: () => removeKey(i) })} >
                    <img src={remove} alt="remove"/>
                  </button>
                </div>
              </div>
            ) 
          })}
        </>
      );
    }
  }

  return (
    <div className="keys-list">
      {displayEditKey && key &&

        <div className="edit-key">
          <label htmlFor="keyFig-edit-pos">Position</label>
          <input
            id="keyFig-edit-pos"
            style={{ marginBottom : 10 }}
            defaultValue={key.pos ? key.pos : null }
            onChange={(e) => setKey({...key, pos: !isNaN(parseFloat(e.target.value)) ? parseFloat(e.target.value) : null})}
            name="pos"
          />

          <label htmlFor="keyFig-edit-number">Nombre</label>
          <input
            id="keyFig-edit-number"
            style={{ marginBottom : 10 }}
            defaultValue={key.number ? key.number : null }
            onChange={(e) => setKey({...key, number: !isNaN(parseFloat(e.target.value)) ? parseFloat(e.target.value) : null })}
            name="number"
          />

          <label htmlFor="keyFig-edit-unit">Unité</label>
          <input
            id="keyFig-edit-unit"
            style={{ marginBottom : 10 }}
            defaultValue={key.unit}
            onChange={(e) => setKey({...key, unit: e.target.value })}
            name="unit"
          />

          {!isCompany &&
            <>
              <label htmlFor="keyFig-edit-title">Titre</label>
              <input
                id="keyFig-edit-title"
                style={{ marginBottom : 10 }}
                defaultValue={key.title}
                onChange={(e) => setKey({...key, title: e.target.value })}
                name="title"
              />
            </>
          }

          <label htmlFor="keyFig-edit-text">texte</label>
          <textarea
            id="keyFig-edit-text"
            style={{ marginBottom : 10 }}
            defaultValue={key.text}
            onChange={(e) => setKey({...key, text: e.target.value })}
            name="text"
          />

          <button className="btn success" type="button" onClick={() => submitkey()}>Valider</button>
          <button className="btn primary" type="button" style={{ marginLeft: 10 }} onClick={() => setDisplayEditKey(false)}>Annuler</button>
        </div>
      }
      {displayAddKey &&

        <div className="edit-key">
          <label htmlFor="keyFig-add-pos">Position</label>
          <input
            id="keyFig-add-pos"
            style={{ marginBottom : 10 }}
            defaultValue={keyFigures.length + 1 }
            onChange={(e) => setKey({...key, pos: !isNaN(parseFloat(e.target.value)) ? parseFloat(e.target.value) : null})}
            name="pos"
          />

          <label htmlFor="keyFig-add-number">Nombre</label>
          <input
            id="keyFig-add-number"
            type="number"
            onChange={(e) => setKey({...key, number: e.target.value })}
            name="number"
          />

          <label htmlFor="keyFig-add-unit">Unité</label>
          <input
            id="keyFig-add-unit"
            onChange={(e) => setKey({...key, unit: e.target.value })}
            name="unit"
          />

          {!isCompany &&
            <>
              <label htmlFor="keyFig-add-title">Titre</label>
              <input
                id="keyFig-add-title"
                onChange={(e) => setKey({...key, title: e.target.value })}
                name="title"
              />
            </>
          }

         
          <label htmlFor="keyFig-add-text">Texte</label>
          <textarea
            id="keyFig-add-text"
            onChange={(e) => setKey({...key, text: e.target.value })}
            name="text"
          />

          <button className="btn success" type="button" onClick={() => addKey()}>Valider</button>
          <button className="btn primary" type="button" style={{ marginLeft: 10 }} onClick={() => setDisplayAddKey(false)}>Annuler</button>
        </div>
      }
      {!displayAddKey && !displayEditKey &&
        <>
        {renderKeysList()}
        <button
          className="btn primary"
          type="button"
          onClick={(e) => addNewKey(e)}>Ajouter un chiffre clé</button>
        </>
      }
    </div>
  )
}
